import type { PreviewProps } from '@xing-com/crate-lebenslauf-xinglets';
import type { Xinglet } from '@xing-com/crate-xinglet';

import { Preview } from './preview';

export default class PreviewXinglet implements Xinglet {
  public getComponent() {
    return (props: PreviewProps): JSX.Element => <Preview {...props} />;
  }
}
